import {Typography} from "@mui/material";

export const toolTipData = {
  averagePositiveSentimentsScore: (
    <>
      <Typography fontSize={12}>Average Sentiment Score recorded across all news articles and social media today</Typography>
      <br />
      <br />
      <Typography fontSize={10}>Source: Auro NLP bots</Typography>
    </>
  ),
  averageNegativeSentimentsScore: (
    <>
      <Typography fontSize={12}>Average Sentiment Score recorded across all news articles and social media today</Typography>
      <br />
      <br />
      <Typography fontSize={10}>Source: Auro NLP bots</Typography>
    </>
  ),
  negativeArticlesByAuroDigital: "recorded the highest Negative Sentiment today amongst all Channels (Auro NLP bots)",
  positiveArticlesByAuroDigital: "recorded the highest Positive Sentiment today amongst all Channels (Auro NLP bots)",
  mostBullishCoinPair: `recorded the highest Positive Sentiment today amongst all digital tokens (Auro NLP bots)`,
  mostBearishCoinPair: `recorded the highest Negative Sentiment today amongst all digital tokens (Auro NLP bots)`,
  mostPositiveBullishCoinChannel: (
    <>
      <Typography fontSize={12}>Sentiment score for the most Bullish Crypto Coin today.</Typography>
      <br />
      <br />
      <Typography fontSize={10}>Source: Auro NLP bots</Typography>
    </>
  ),
  mostNegativeBearishCoinChannel: (
    <>
      <Typography fontSize={12}>Sentiment score for the most Bearish Crypto Coin today.</Typography>
      <br />
      <br />
      <Typography fontSize={10}>Source: Auro NLP bots</Typography>
    </>
  ),
};
